module.exports = __webpack_public_path__ + "img/aplus-may24.dea72b6d.svg";